var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.502 8.225l-.9 2.445a.374.374 0 01-.704 0l-.9-2.445a.375.375 0 00-.223-.222L1.33 7.102a.375.375 0 010-.704l2.445-.9a.375.375 0 00.222-.223l.9-2.445a.375.375 0 01.705 0l.9 2.445a.375.375 0 00.223.222l2.445.901a.375.375 0 010 .704l-2.445.9a.375.375 0 00-.223.223v0zM8.25.75V3M9.375 1.875h-2.25M10.5 3.375v1.5M11.25 4.125h-1.5",
    stroke: "#4E8278",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSparkle;